// TEXT COMPLIANCE
export const blockedPhrasesKey = "blockedPhrases";

// CONSULTATION
export const availabilitiesKey = ["availabilities"];

// MYM CLOUD
export const collectionsKey = "collections";

// PLAYLIST
export const playlistsKey = "playlists";
export const playlistKey = "playlist";

// POST
export const postsKey = ["posts"];
export const postKey = ["post"];
export const postCalendarRestrictionsKey = ["post-calendar-restrictions"];
export const postCalendarDatesKey = ["post-calendar-dates"];

// PUSH

export const pushKey = "push";
export const pushCreationKey = "create-push";
export const pushCalendarRestrictionsKey = "push-calendar-restrictions";
export const pushCalendarDatesKey = "push-calendar-dates";
export const pushCreatePresignedUrlKey = "push-create-presigned-url";
export const pushUploadMediaKey = "push-upload-media";
